import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=a5b2b5d2&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=a5b2b5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b2b5d2",
  null
  
)

export default component.exports